import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
    title: '拼搏者文化',
    img: 'http://www.cdg.com.cn/images/upload/0771e4e4-0502-426c-ae76-ad2814b360ec_003.jpg',
    isshowmap: false,
    menuShow: true,
}

const mutations = {
    setTitle(state, v) {
        state.title = v
    },
    setImg(state, v) {
        state.img = v
    },
    setmap(state, v) {
        state.isshowmap = v
    },
    set_menuShow(state, v) {
        state.menuShow = v
    }
}
const modulesFiles = require.context('./module', false, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, key) => {
    let name = key.replace(/^\.\/(.*)\.\w+$/, '$1');
    modules[name] = modulesFiles(key).default
    return modules
}, {})

const store = new Vuex.Store({
    state,
    mutations,
    modules
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js